class cAdminQuotes {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        $('#subscription-amount, #purchase-amount').on('blur', function () {
            let number = Number.parseFloat(this.value).toFixed(2);
            this.value = number;
        });
    }
}
